<template>
  <div class="map-header">
    <div class="map-header__indicator">
      <svgicon
        name="mobile-indicator"
        color="var(--gray_03)"
        height="1.25rem"
        width="1.25rem"
        class="map-header__indicator__icon"
      ></svgicon>
      <span class="map-header__indicator__label">
        click on the grid to find countries on the map
      </span>
    </div>
    <button
      @click="$emit('toggleItem', null, false)"
      :class="['map-header__button', { visible: selectedCountryId !== null }]"
    >
      Reset
    </button>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "HeaderClassification",
  computed: {
    ...mapGetters({
      selectedCountryId: "ui/selectedCountryId",
    }),
  },
};
</script>

<style lang="scss" scoepd>
.map-header {
  @include dida-S;
  color: $ui-white;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 7.5vh;
  padding: 0 toRem(10);
  border-bottom: $white-border;

  &__indicator {
    display: flex;
    align-items: center;
    color: $gray-03;
    &__icon {
      margin-right: toRem(2);
    }
    &__label {
      white-space: nowrap;
      flex-shrink: 1;
      transition: all 0.3s ease;
      @include dida-S;
    }
  }

  &__button {
    opacity: 0;
    visibility: hidden;
    text-transform: uppercase;
    transition: all 0.3s ease;
    @include link-xs;

    &.visible {
      opacity: 1;
      visibility: visible;
    }
  }
}

.tablet {
  .map-header {
    height: 4.7vh;
    width: 32.682vw;
    padding: 1.76vh 0 1vh 0;
    &__indicator {
      &__label {
        white-space: normal;
      }
    }
  }
}
</style>
